import { Title, Text, Space } from "@mantine/core";

function FAQ(props) {

    const FAQs = [
        {
            question: "What time does the walk start?",
            answer: "The walk starts at 11:30 AM."
        },
        {
            question: "How much do tickets cost?",
            answer: "There is a minimum $10 donation per person.  Please purchase your tickets from the World Partnership Walk desk in the back of Jamatkhana while supplies last."
        },
        {
            question: "What is the deadline to purchase my ticket?",
            answer: "Tickets are now sold out. The last day to purchase your ticket was Friday, May 16.  Tickets will not be available at the picnic site."
        },
        {
            question: "What should I bring with me on the day of the walk?",
            answer: "We recommend everyone wear a comfortable pair of walking shoes, bring sunglasses and hats, a reusable water bottle, and an umbrella.  Please also bring your own picnic chairs and/or picnic blankets as seating is very limited."
        },
        {
            question: "What facilities are available at the walk site?",
            answer: "Washrooms, playground, grassy playing areas, walking trails, and a limited number of picnic tables."
        },
        {
            question: "What happens if it rains?",
            answer: "The event will be held rain or shine unless there is severely inclement weather (severe thunderstorms, hail, etc).  Please dress appropriately for the forecasted weather."
        }
    ]

    return (
        <div>
            <Space h="md"></Space>
            {FAQs.map((faq, index) => {
                return (
                    <div key={index} style={{textAlign: "left"}}>
                        <Title order={4}>
                            {faq.question}
                        </Title>
                        <Text>
                            {faq.answer}
                        </Text>
                        <Space h="md"></Space>
                    </div>
                )
            })}
        </div>
    )
}
export default FAQ;